<ng-container>
  <vy-footer
    [legalConfig]="this.loadConfigFooter(this.userType())"
    [showCorporateFooter]="false"
    [showFooterDisclaimer]="false"
  ></vy-footer>
</ng-container>
